import { $gte as __gte, createExpressionOperator } from "../../_predicates";
const $gte = createExpressionOperator(__gte);
export {
  $gte
};
